import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DateRangeSelectorComponent } from './date-range-selector.component';
import { DateRangeSelectorService } from './date-range-selector.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    TranslateModule,
    FormsModule,
    MatFormFieldModule,
    MatRadioModule,
    MatInputModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatButtonModule,
  ],
  declarations: [DateRangeSelectorComponent],
  exports: [DateRangeSelectorComponent],
  providers: [DateRangeSelectorService],
})
export class DateRangeSelectorModule {}
